var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,65.098041%,92.941177%)",
      fillOpacity: 1
    },
    d: "M 2.25 9.75 C 2.25 13.890625 5.609375 17.25 9.75 17.25 C 13.890625 17.25 17.25 13.890625 17.25 9.75 C 17.25 5.609375 13.890625 2.25 9.75 2.25 C 5.609375 2.25 2.25 5.609375 2.25 9.75 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 13.761719 5.800781 C 14.175781 6.515625 14.074219 7.351562 13.535156 7.660156 C 13 7.972656 12.226562 7.640625 11.8125 6.925781 C 11.398438 6.207031 11.5 5.371094 12.035156 5.0625 C 12.574219 4.753906 13.347656 5.082031 13.761719 5.800781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.549021%,20.784314%,40.000001%)",
      fillOpacity: 1
    },
    d: "M 1.5 9.75 C 1.5 14.304688 5.195312 18 9.75 18 C 11.472656 18 13.070312 17.472656 14.390625 16.570312 C 14.179688 17.511719 14.460938 18.5 15.144531 19.183594 L 17.53125 21.570312 C 18.632812 22.648438 20.398438 22.640625 21.488281 21.550781 C 22.578125 20.457031 22.589844 18.695312 21.511719 17.59375 L 19.125 15.207031 C 18.445312 14.527344 17.46875 14.242188 16.53125 14.445312 C 17.492188 13.066406 18.003906 11.429688 18 9.75 C 18 5.195312 14.304688 1.5 9.75 1.5 C 5.195312 1.5 1.5 5.195312 1.5 9.75 M 16.5 9.75 C 16.5 13.476562 13.476562 16.5 9.75 16.5 C 6.023438 16.5 3 13.476562 3 9.75 C 3 6.023438 6.023438 3 9.75 3 C 13.476562 3 16.5 6.023438 16.5 9.75 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.29d5a84630d5049c1e33bf028da39381.svg";
export { ForwardRef as ReactComponent };